import { render, staticRenderFns } from "./detailDrawer.vue?vue&type=template&id=ca5de646&scoped=true"
import script from "./detailDrawer.vue?vue&type=script&lang=js"
export * from "./detailDrawer.vue?vue&type=script&lang=js"
import style0 from "./detailDrawer.vue?vue&type=style&index=0&id=ca5de646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5de646",
  null
  
)

export default component.exports